export const getUserAgent = (): 'Mobile' | 'Desktop' => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return 'Mobile'
    } else {
        return 'Desktop'
    }
}
